import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateProfile as apiUpdateProfile } from "../../api/apiProfile";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

/**
 * Hook لتحديث بيانات البروفايل
 */
export function useUpdateProfile() {
    const queryClient = useQueryClient();

    const {
        mutate: updateProfile,
        isPending: isUpdating,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiUpdateProfile(req),
        onSuccess: (response) => {
            toast.success(response.message || 'Profile updated successfully');

            // تحديث الكاش
            queryClient.invalidateQueries({
                queryKey: ["profile"],
            });

            // تحديث بيانات المستخدم في auth/me أيضاً
            queryClient.invalidateQueries({
                queryKey: ["auth", "me"],
            });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Failed to update profile");
            toast.error(msg);
        },
    });

    return { updateProfile, isUpdating, error, results };
}
